import React from 'react';
import { motion } from 'framer-motion';
import { projectsData } from '../../data/contentData';

// const T = {
//   bg: '#000', surface: '#0A0A0A', raised: '#111', border: '#1C1C1E',
//   text: '#FFF', sec: '#8E8E93', ter: '#48484A',
//   accent: '#007AFF', accentDim: 'rgba(0,122,255,0.12)',
// };

const PROJECT_STYLE = {
  'scm-backorder': { icon: '📦', colors: ['#7C3AED', '#4338CA'] },
};
const FALLBACK = { icon: '🧠', colors: ['#7C3AED', '#4338CA'] };

// const ProjectIcon = () => (
//   <svg width="44" height="44" viewBox="0 0 44 44" fill="none">
//     <defs>
//       <linearGradient id="proj-grad" x1="0" y1="0" x2="1" y2="1">
//         <stop offset="0%" stopColor="#007AFF" />
//         <stop offset="100%" stopColor="#5AC8FA" />
//       </linearGradient>
//     </defs>
//     <rect x="4" y="10" width="36" height="28" rx="6" fill="url(#proj-grad)" />
//     <path d="M4 14a4 4 0 014-4h10l3 4h15a4 4 0 014 4v2H4v-6z" fill="#FFFFFF" opacity="0.18" />
//     <path d="M14 24h16M14 28h12" stroke="#FFFFFF" strokeWidth="1.5" strokeLinecap="round" opacity="0.85" />
//   </svg>
// );

const ProjectsList = ({ persona, projects = projectsData, onSelectProject }) => {

// const ProjectsList = ({ persona, onSelectProject }) => {
  const heading = persona === 'recruiter' ? 'Case Studies' : 'Projects';
  const subheading = persona === 'recruiter'
    ? 'Open a case study for the notebook, repo, and report.'
    : 'Open a project to access the notebook, repo, and report.';

  return (
    <div className="w-full min-h-full bg-pure-black text-pure-white" style={{ fontFamily: "-apple-system,BlinkMacSystemFont,'SF Pro Display',sans-serif" }}>
      <div className="max-w-4xl mx-auto px-6 py-8 text-center">
        <motion.div initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.4 }} style={{ textAlign: 'center' }}>
          {/* <h1 style={{ fontSize: 26, fontWeight: 800, letterSpacing: '-0.02em', margin: '0 0 6px' }}>{heading}</h1> */}
          <h1 className="text-2xl font-extrabold tracking-tight mb-1">{heading}</h1>
          {/* <p style={{ fontSize: 13, color: T.sec, margin: '0 0 28px' }}>{subheading}</p> */}
          <p className="text-sm text-gray-400">{subheading}</p>
        </motion.div>
      </div>

      {/*
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, minmax(140px, 1fr))',
            gap: 20,
          }}
        >
          {projectsData.map((p, i) => (
      */}
      <div className="flex flex-wrap justify-center gap-10 md:gap-14 px-6 pb-12">
        {projects.map((p, i) => {
          const style = p.icon ? { icon: p.icon, colors: p.colors } : (PROJECT_STYLE[p.slug] || FALLBACK);
          return (
            <motion.button
              key={p.slug}
              data-testid="project-tile"
              initial={{ opacity: 0, scale: 0.5 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.1 + i * 0.06, type: 'spring', stiffness: 300, damping: 20 }}
              whileHover={{ scale: 1.12, y: -6 }}
              whileTap={{ scale: 0.88 }}
              onClick={() => onSelectProject(p.slug)}
              className="flex flex-col items-center gap-2.5 group outline-none bg-transparent border-0 cursor-pointer p-0"
              // style={{
              //   background: 'transparent', border: 'none', cursor: 'pointer',
              //   padding: '14px 8px', borderRadius: 14,
              //   display: 'flex', flexDirection: 'column', alignItems: 'center',
              //   gap: 10, transition: 'background 0.2s',
              // }}
              // onMouseEnter={(e) => (e.currentTarget.style.background = 'rgba(255,255,255,0.04)')}
              // onMouseLeave={(e) => (e.currentTarget.style.background = 'transparent')}
            >
              <div
                data-testid="tile-icon"
                className="w-16 h-16 md:w-[72px] md:h-[72px] rounded-[18px] md:rounded-[20px] flex items-center justify-center transition-shadow duration-300"
                style={{
                  backgroundImage: `linear-gradient(145deg, ${style.colors[0]}, ${style.colors[1]})`,
                  boxShadow: `0 4px 20px ${style.colors[0]}50, inset 0 1px 0 rgba(255,255,255,0.1)`,
                  // width: 72, height: 72, borderRadius: 18,
                  // background: T.raised, border: `1px solid ${T.border}`,
                  // display: 'flex', alignItems: 'center', justifyContent: 'center',
                  // boxShadow: '0 4px 14px rgba(0,0,0,0.4), inset 0 1px 0 rgba(255,255,255,0.06)',
                }}
              >
                {/* <ProjectIcon /> */}
                <span className="text-3xl md:text-[34px] select-none">{style.icon}</span>
              </div>
              <span
                data-testid="tile-label"
                className="text-[11px] text-gray-500 group-hover:text-pure-white transition-colors font-medium tracking-wide max-w-[100px] text-center"
              >
              {/* <div style={{ fontSize: 12, fontWeight: 600, color: T.text, textAlign: 'center', lineHeight: 1.3, maxWidth: 130 }}> */}
                {p.title}
              </span>
            </motion.button>
          );
        })}
      </div>
    </div>
  );
};

export default ProjectsList;
